'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;
// import { Helper } from 'helpers/support';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _visaIcon3x = require('assets/img/payment/visaIcon@3x.png');

var _visaIcon3x2 = _interopRequireDefault(_visaIcon3x);

var _arrowForward2x = require('assets/img/account/arrowForward@2x.png');

var _arrowForward2x2 = _interopRequireDefault(_arrowForward2x);

var _arrowForwardWhite2x = require('assets/img/payment/arrowForwardWhite@2x.png');

var _arrowForwardWhite2x2 = _interopRequireDefault(_arrowForwardWhite2x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardItem = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(CardItem, _Component);

  function CardItem() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CardItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CardItem.__proto__ || (0, _getPrototypeOf2.default)(CardItem)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = '/error-img.svg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CardItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          leftArrow = _props.leftArrow,
          selected = _props.selected;

      var styles = require('./CardItem.scss');
      return _react2.default.createElement(
        'div',
        {
          className: styles.container,
          style: selected ? { backgroundColor: '#5ECCCB' } : null
        },
        _react2.default.createElement(
          'div',
          { className: styles.firstDiv },
          _react2.default.createElement('img', { src: _visaIcon3x2.default, className: styles.img }),
          _react2.default.createElement(
            'div',
            {
              className: styles.title,
              style: selected ? { color: '#fff' } : null
            },
            title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.secondDiv },
          leftArrow && _react2.default.createElement(
            'div',
            { className: styles.leftArrow },
            leftArrow
          ),
          _react2.default.createElement('img', {
            src: selected ? _arrowForwardWhite2x2.default : _arrowForward2x2.default,
            className: styles.arrowForward
          })
        )
      );
    }
  }]);
  return CardItem;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object,
  title: _react.PropTypes.string,
  leftArrow: _react.PropTypes.string,
  selected: _react.PropTypes.bool
}, _temp2);
exports.default = CardItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/CardItem.js
// module id = 1618
// module chunks = 0